import type { Day } from 'services/recurrenceRuleBuilder';

// The days of the week, Monday-first (the order the recurrence UI lists them,
// and the order `moment().day()` is shifted into).
//
// This lives here rather than in components/recurrenceOptions because
// hooks/useStoredBooking needs it too, and that component already imports
// `getInitialValues` from that hook — an import cycle which left TypeScript
// unable to infer the type of the weekday default in the hook.
export const WeekDay: readonly Day[] = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];
